import { z } from 'zod';

export const changeRetirementDateGetResponseSchema = z.object({
  data: z.object({ retirement_age: z.number().optional() }),
  response: z.object({ date: z.string(), messages: z.array(z.string()), status: z.number(), type: z.string() }),
});
